import PopupBase from "@luminecence/composants/PopupBase"
import { css, html } from "lit"
import "@luminecence/composants/BoutonRadio"
import "@luminecence/composants/BoutonsRadio"

export const TRI = {
  AZ: { type: "AZ", label: "nom croissant" },
  ZA: { type: "ZA", label: "nom décroissant" },
  SHINY: { type: "SHINY", label: "shiny" },
  PARFAIT: { type: "PARFAIT", label: "parfait" },
}

export default class PopupTri extends PopupBase {
  static properties = {
    valeur: { type: String },
    erreur: { type: String },
    triAAfficher: { type: Array },
  }

  static styles = [
    PopupBase.styles,
    css`
        :host .conteneur .formulaire .option {
            display: flex;
            flex-direction: row;
            gap: 1rem;
        }
        `,
  ]

  constructor() {
    super()
    this.valeur = ""
    this.erreur = ""
    this.triAAfficher = []
  }

  render() {
    return html`
            <div class="conteneur">
                <h1>Trier par</h1>
                ${this.erreur ? html`<span class="erreur">${this.erreur}</span>` : ""}
                <div class="formulaire">
                    <p-boutons-radio .valeur=${this.valeur} @evenementSelectionBoutonRadio=${this.changerValeur}>
                      ${this.triAAfficher.map(
                        (tri) => html`
                        <label class="option">
                            <p-bouton-radio id=${tri.type.toLowerCase()} .valeur=${tri.type} .selectionne=${this.valeur === tri.type} .texte=${tri.label}></p-bouton-radio>
                        </label>
                    `,
                      )}
                  </p-boutons-radio>
                </div>
            </div>
            ${this.renderBoutons()}
        `
  }

  changerValeur(event) {
    this.valeur = event.detail?.valeur ?? ""
  }

  valider() {
    this.dispatchEvent(
      new CustomEvent("valider", {
        bubbles: true,
        composed: true,
        detail: { valeur: this.valeur },
      }),
    )
    this.fermerPopup()
  }

  annuler() {
    this.dispatchEvent(
      new CustomEvent("valider", {
        bubbles: true,
        composed: true,
        detail: false,
      }),
    )
    this.fermerPopup()
  }
}

customElements.define("p-popup-tri", PopupTri)
